import React from 'react';
import ApexChart from 'react-apexcharts';

const Chart = (props) => {
  return <ApexChart {...props} />;
};

Chart.displayName = 'Chart';
export default Chart;
